import {
  Box,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CustomDetailPreOrder, CustomOrder } from "../components";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { RootState } from "../../../redux/store";
import { Commande, getCommandes, getPreCommandes } from "../slices/orderSlice";
import {
  fetchPreOrderDetails,
  selectPreOrder,
  clearOrderDetails,
  clearPreOrderDetails,
} from "../slices/detailOrderSlice";
import { CustomLoading, CustomLoadingDetail } from "../../../components/shared";

const ListPreCommandePageRepresentant = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { error, dataPreCommande, loadingPreCommande, errorPreCommande } =
    useAppSelector((state: RootState) => state.orderSlice);
  const { businessId, name } = useAppSelector((state) => state.authSlice);

  const { selectedPreOrder, dataPreOrder, errorPreOrder, loadingPreOrder } =
    useAppSelector((state: RootState) => state.detailOrderSlice);
  const { direction } = useAppSelector((state) => state.languageSlice);

  const [isLoadingNewPreDetails, setIsLoadingNewPreDetails] = useState(false);

  const [filterPreOrder, setFilterPreOrder] = useState("");

  const [statusFilterPreOrder, setStatusFilterPreOrder] = useState("");

  useEffect(() => {
   
    dispatch(getPreCommandes());

    return () => {
     
      dispatch(clearPreOrderDetails());
    };
  }, [dispatch, businessId, name]);

  const handlePreOrderClick = (orderNumber: string) => {
    dispatch(selectPreOrder(orderNumber));
    setIsLoadingNewPreDetails(true);
    dispatch(fetchPreOrderDetails(orderNumber)).finally(() => {
      setIsLoadingNewPreDetails(false);
    });
  };

  const handleFilterPreOrderChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFilterPreOrder(event.target.value);
  };

  const handleStatusFilterPreOrderChange = (
    event: SelectChangeEvent<string>
  ) => {
    setStatusFilterPreOrder(event.target.value as string);
  };

  const filteredDataPreOrder = dataPreCommande?.filter((order) => {
    const filterLowerCase = filterPreOrder.toLowerCase();
    const statusFilterPreOrderLowerCase = statusFilterPreOrder.toLowerCase();
    return (
      (!statusFilterPreOrder ||
        (order.StatutFinal &&
          order.StatutFinal.toLowerCase().includes(
            statusFilterPreOrderLowerCase
          ))) &&
      ((order.StatutFinal &&
        order.StatutFinal.toLowerCase().includes(filterLowerCase)) ||
        new Date(order.DateCommande)
          .toLocaleDateString()
          .includes(filterPreOrder) ||
        (String(order.NumeroCommande) &&
          String(order.NumeroCommande)
            .toLowerCase()
            .includes(filterLowerCase)) ||
        order.MontantTTC.toString().includes(filterPreOrder))
    );
  });

  useEffect(() => {
    if (filteredDataPreOrder?.length === 0 && selectedPreOrder) {
      dispatch(clearPreOrderDetails());
    }
  }, [filteredDataPreOrder, selectedPreOrder, dispatch]);
  return (
    <>
      <Typography
        variant="h5"
        sx={{
          marginBottom: "2%",
          direction: direction === "ltr" ? "ltr" : "rtl",
        }}
      >
        {t("commandesClient.titlePreOrder")}
      </Typography>
      <Grid container columnGap={2}>
        <Grid item xs>
          <TextField
            fullWidth
            value={filterPreOrder}
            onChange={handleFilterPreOrderChange}
            label={t("commandesClient.filterTextPreOrder")}
            sx={{ marginBottom: "2%" }}
          />
        </Grid>
        <Grid item xs>
          <Select
            fullWidth
            value={statusFilterPreOrder}
            onChange={handleStatusFilterPreOrderChange}
            displayEmpty
            sx={{ marginBottom: "2%" }}
          >
            <MenuItem value="">
              <em>{t("commandesClient.filterStatut")}</em>
            </MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Created">Created</MenuItem>
            <MenuItem value="Validated">Validated</MenuItem>
            <MenuItem value="Canceled">Canceled</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Grid container mb={2}>
        <Grid item xs={12} sm={12} md={5} lg={6}>
          <Box sx={{ maxHeight: "500px", overflowY: "auto", padding: "2%" }}>
            {loadingPreCommande && <CustomLoading />}
            {errorPreCommande && <Typography>{error}</Typography>}
            {filteredDataPreOrder &&
            filteredDataPreOrder.length > 0 &&
            !loadingPreCommande ? (
              filteredDataPreOrder.map((order: Commande, index: number) => (
                <CustomOrder
                  key={index}
                  order={order}
                  isSelected={selectedPreOrder === order.NumeroCommande}
                  onClick={() => handlePreOrderClick(order.NumeroCommande)}
                />
              ))
            ) : !loadingPreCommande ? (
              <Typography>{t("commandesClient.videCommande")}</Typography>
            ) : null}
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={7} lg={6} sx={{ paddingLeft: "3%" }}>
          {loadingPreOrder || isLoadingNewPreDetails ? (
            <CustomLoadingDetail />
          ) : errorPreOrder ? (
            <Typography>{errorPreOrder}</Typography>
          ) : dataPreOrder && selectedPreOrder != null ? (
            <CustomDetailPreOrder
              orderDetails={dataPreOrder}
              onFetchOrderDetails={() =>
                dispatch(fetchPreOrderDetails(selectedPreOrder))
              }
            />
          ) : (
            <Typography>{t("commandesClient.noItemSelected")}</Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ListPreCommandePageRepresentant;
